<template>
  <div>
    <v-row>
      <span v-show="false">{{title}}</span>
      <v-col cols="12" md="6">
        <sanad-list-tabs :summary="true"></sanad-list-tabs>
      </v-col>
      <v-col cols="12" md="6">
        <last-accounts-tabs></last-accounts-tabs>
      </v-col>
      <v-col cols="12" md="6">
        <documents-chart></documents-chart>
      </v-col>
      <v-col cols="12" md="6">
        <accounts-with-differences></accounts-with-differences>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        <last-documents></last-documents>
      </v-col>
    </v-row>
  </div>
</template>
<script>


import LastAccounts from "@/views/modulePages/accountingModule/LastAccounts";
import DocumentsChart from "@/views/modulePages/accountingModule/DocumentsChart";
import AccountsChart from "@/views/modulePages/accountingModule/AccountsChart";
import LastDocuments from "@/views/modulePages/accountingModule/LastDocs";
import SanadListTabs from "@/views/modulePages/accountingModule/SanadListTabs";
import LastAccountsTabs from "@/views/modulePages/accountingModule/LastAccountsTabs";
import AccountsWithDifferences from "@/views/modulePages/accountingModule/AccountsWithDifferences";
export default {
  name: "AccountingHome",
  components: {
    AccountsWithDifferences,
    LastAccountsTabs,
    SanadListTabs,
    LastDocuments,
    AccountsChart,
    DocumentsChart,
    LastAccounts
  },
  props: {
    id: {},
  },
  data() {
    return {
    }
  },
  computed:{
    title(){
      return this.setDocumentTitle('داشبورد حسابداری')
    }
  }
}
</script>

<style scoped lang="scss"></style>

